/*eslint-disable*/
import React from "react";
import { useTranslation, Trans } from 'react-i18next';
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui core components
import { Button, List, ListItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

import styles from "assets/jss/material-kit-react/components/footerStyle.js";
import brandImage from "assets/img/iese-logo-footer.png";

const useStyles = makeStyles(styles)


export default function Footer(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { whiteFont} = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const currentyear = new Date().getFullYear();
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div className={classes.flexSpaceBetween}>
          <span className="regular-b300 cl-secondary-900">© Copyright, {currentyear}. IESE Business School. University of Navarra.</span>
          <span>
          <Button className={classes.buttonDisplay + " regular-b300 cl-secondary-900"} variant = "text" onClick={()=>{window.location.assign(t("PrivacyUrl"))}}>{t("Privacy")}</Button>
          <Button className={classes.buttonDisplay + " regular-b300 cl-secondary-900"} variant = "text" onClick={()=>{window.location.assign(t("LegalNoticeUrl"))}}>{t("LegalNotice")}</Button>
          <Button className={classes.buttonDisplay + " regular-b300 cl-secondary-900"} variant = "text" onClick={()=>{window.location.assign(t("AccessibilityUrl"))}}>{t("Accessibility")}</Button>
          </span>
          {/* <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
            <img
                    src={brandImage}
                    className={classes.img}
                    alt="brand"
                />
            </ListItem>
    
          </List> */}
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool
};
